import AkoBonusIcon from 'assets/images/AkoBonusIcon.svg?react';
import { t } from 'i18next';
import Warning from 'shared/components/warning';

import './styles.scss';

interface AkoBonusInfoToastProps {
	numOfCouponsToAdd: number;
	futureBonusValue: number;
	minOutcomeOdds: number;
	isBonusBalance: boolean;
	bonusAmount: number;
}

const AkoBonusInfoToast = (props: AkoBonusInfoToastProps) => {
	const { numOfCouponsToAdd, futureBonusValue, minOutcomeOdds, isBonusBalance, bonusAmount } = props;
	const MAX_BONUS_AMOUNT = 10000;

	const getEventText = () => {
		if (numOfCouponsToAdd >= 5) {
			return t('eventTxtMoreThan5');
		}

		if (numOfCouponsToAdd > 1 && numOfCouponsToAdd < 5) {
			return t('eventInPlural');
		}

		return t('eventInSingular');
	};

	if (isBonusBalance) {
		return <Warning type="warning" title={t('information')} desc={t('akoBonusNotAvailable')} cyTestRef="forbidden-akobooster" />;
	}

	const renderContent = () => {
		if (bonusAmount === MAX_BONUS_AMOUNT) {
			return <p>{t('maxBonusAmountReached')}</p>;
		}

		return (
			<p
				dangerouslySetInnerHTML={{
					__html: t('addSlipsToBetslipForAkoBonus', {
						numOfCouponsToAdd: numOfCouponsToAdd,
						futureBonusValue: futureBonusValue,
						minOutcomeOdds: minOutcomeOdds,
						eventText: getEventText(),
					}),
				}}
			/>
		);
	};

	return (
		<div className="AkoBonusInfoToast">
			<div className="AkoBonusInfoToast__icon">
				<AkoBonusIcon />
			</div>
			<div className="AkoBonusInfoToast__content" data-cy="akobooster-info">
				{renderContent()}
			</div>
		</div>
	);
};

export default AkoBonusInfoToast;
